import axiosInstance from "./axiosConfig";

export const authAPI = {
  login: (data) => axiosInstance.post("/accounts/login/", data),

  register: (data) => axiosInstance.post("/accounts/users/create/", data),

  forgotPassword: (data) =>
    axiosInstance.post("/accounts/forgot-password/", data),

  resetPassword: (data) =>
    axiosInstance.post("/accounts/reset-password-otp/", data),

  logout: (data) => axiosInstance.post("/accounts/logout/", data),

  getProfile: () => axiosInstance.get("/accounts/user/profile/"),

  checkStatus: () => axiosInstance.get("/accounts/check-user-status/"),

  getAllUsers: () => axiosInstance.get("/accounts/users/"),

  getUserById: (id) => axiosInstance.get(`/accounts/users/${id}/`),

  updateUser: (id, data) =>
    axiosInstance.put(`/accounts/users/${id}/update/`, data),

  deleteUser: (id) => axiosInstance.delete(`/accounts/users/${id}/delete/`),
};
